const faqDb = {
  items: [
    {
      id: "delivery-time",
      question: "Сколько времени занимает доставка после заказа?",
      answer: [
        "Обычно доставляем на следующий день после оформления заказа или в ближайшее удобное окно по согласованию.",
      ],
    },
    {
      id: "products",
      question: "Что именно вы поставляете?",
      answer: [
        `Поставляем основные виды топлива и нефтепродуктов стандарта Евро-5:
         дизельное топливо и его аналоги,
         бензин,
         керосин.`
      ],
    },
    {
      id: "min-volume",
      question: "От какого объёма возможна поставка?",
      answer: ["Дизельное топливо - от 500 литров. Бензин - от 5000 литров."],
    },
    {
      id: "regions",
      question: "В какие районы вы доставляете?",
      answer: ["Работаем по Москве и Московской области. Также можем организовать поставки в другие регионы России - по запросу и при наличии логистической возможности."],
    },
    {
      id: "supply-source",
      question: "Откуда вы возите топливо?",
      answer: ["Закупки осуществляем у крупнейших производителей с отгрузкой напрямую с заводов и нефтебаз (в их число входят такие компании, как Лукойл, Роснефть, Газпром, Татнефть и другие)."],
    },
    {
      id: "quality-docs",
      question: "Как подтверждается качество топлива?",
      answer: [`
            К каждой поставке прилагаются паспорт качества и сертификаты соответствия.
По запросу оставляем контрольную пробу топлива.
        `],
    },
    {
      id: "promotions",
      question: "Где смотреть акции и специальные условия?",
      answer: [`
            Все актуальные акции, скидки и специальные предложения
            размещаем на сайте. Также менеджер подскажет действующие
            условия при обращении.
        `],
    },
    {
      id: "how-to-order",
      question: "Как быстрее всего оформить заказ или получить консультацию?",
      answer: [`
            Оставьте заявку на сайте или свяжитесь с нами по телефону/в
            мессенджере - поможем подобрать вид топлива, рассчитаем
            объём и согласуем удобное время доставки.
        `],
    },
  ],
};

export default faqDb;
